import React from 'react'
import { Player } from '@lottiefiles/react-lottie-player'
import scanAnimationData from './document-scan.lottie.json'
import mapAddAnimationData from './list-add.lottie.json'
import ArrowAnimation from './ArrowAnimation'

const ScanAnimationPlayer = () => {
  return (
    <div className='relative' style={{ width: 400, height: 400 }}>
      <Player autoplay loop src={scanAnimationData} style={{ width: 400, height: 400 }} />
      <div className='absolute bg-white' style={{ top: 95, left: 180, width: 40, height: 20 }}></div>
    </div>
  )
}
const ScanAnimation = () => {
  return (
    <div className='relative overflow-hidden' style={{ width: 210, height: 192 }}>
      <div style={{ top: -115, left: -40, position: 'absolute' }}>
        <ScanAnimationPlayer />
      </div>
    </div>
  )
}

const MapAddAnimationPlayer = () => {
  return (
    <div className='relative' style={{ width: 200, height: 400 }}>
      <Player autoplay loop src={mapAddAnimationData} style={{ width: 400, height: 200 }} />
    </div>
  )
}

const MapAddAnimation = () => {
  return (
    <div className='relative overflow-hidden' style={{ width: 120, height: 192 }}>
      <div style={{ left: -140, position: 'absolute' }}>
        <MapAddAnimationPlayer />
      </div>
    </div>
  )
}

const ContextualMapAnimation = () => {
  return (
    <div className='flex rounded-lg shadow-lg'>
      <ScanAnimation />
      <MapAddAnimation />
    </div>
  )
}

const ArticleAnalysisChart = () => {
  return (
    <div className='py-10 transform scale-75 md:scale-1'>
      <div className='text-xl tracking-wide font-light mb-4'>Contextual Analysis</div>
      <div className='flex items-center'>
        <div className='flex'>
          <div>
            <div className='flex flex-row-reverse items-center mb-4'>
              <span>
                <ArrowAnimation />
              </span>
              <span className='bg-black text-white rounded px-2 py-1 shadow-lg'>PTAG.js</span>
            </div>
            <div className='flex flex-row-reverse items-center'>
              <span>
                <ArrowAnimation />
              </span>
              <span className='bg-black text-white rounded px-2 py-1 shadow-lg'>Poplink dashboard</span>
            </div>
          </div>
        </div>
        <ContextualMapAnimation />
      </div>
      <div className='text-right relative pt-8'>
        <div className='absolute right-10 top-0 transform rotate-90'>
          <ArrowAnimation />
        </div>
        <span className='bg-black text-white rounded px-2 py-1 shadow-lg'>New context maps</span>
      </div>
    </div>
  )
}

export default ArticleAnalysisChart
